export default {

    // ieVersion: Number(document.documentMode),//IE版本

    //判断变量是否为空
    isEmpty: function (obj) {
        if (!obj || obj === '') return true;
        else if (obj instanceof Array && obj.length === 0) return true;
        else if (obj instanceof Object) {
            for (let key in obj) {
                return false;
            }
            return true;
        }
        return false;
    },
    /**
     * 获取数组或对象里的元素
     * @param obj
     * @param key
     */
    arrayGet: function (obj, key) {
        let value = null;
        try {
            value = eval("obj." + key);
        } catch (e) {
            value = null;
        }

        return value;
    },
    //判断是否是数字
    isNum: function (obj) {
        return typeof obj === 'number';
    },
    //判断是否为字符串
    isString: function (obj) {
        return typeof obj === 'string';
    },
    //判断是否为数组
    isArray: function (obj) {
        return obj instanceof Array;
    },
    //判断是否为对象
    isObject: function (obj) {
        return Object.prototype.toString.call(obj) === '[object Object]'
    },
    //数组去重
    arrayUnique: function (arr) {
        var ret = [];
        for (var i = 0; i < arr.length; i++) {
            for (var j = i + 1; j < arr.length; j++) {
                if (arr[i] === arr[j]) {
                    ++i;
                }
            }
            ret.push(arr[i]);
        }
        return ret;
    },
    //判断两个数组是否相等
    isArrayEqual: function (a1, a2) {
        if ((!a1 && a2) || (a1 && !a2)) return false;
        if (a1.length !== a2.length) return false;
        a1 = [].concat(a1);
        a2 = [].concat(a2);
        a1 = a1.sort();
        a2 = a2.sort();
        for (var i = 0, n = a1.length; i < n; i++) {
            if (a1[i] !== a2[i]) return false;
        }
        return true;
    },

    /**
     * 将对象的属性置为空值
     * @param obj 要设置的对象
     */
    emptyObjFields: function (obj) {
        let self = this;
        Object.keys(obj).forEach(function (key) {
            if (self.isString(obj[key])) {
                obj[key] = ""
            } else if (self.isNum(obj[key])) {
                obj[key] = 0
            } else if (self.isObject(obj[key])) {
                obj[key] = {};
            } else if (self.isArray(obj[key])) {
                obj[key] = [];
            } else {
                obj[key] = '';
            }
        })
    },
    /**
     * 给指定的对象的属性赋值
     * @param toObj 被赋值的对象
     * @param fromObj 来源对象
     */
    assignObj: function (toObj, fromObj) {
        if (!this.isObject(toObj) || !this.isObject(fromObj)) return;
        Object.keys(toObj).forEach(function (key) {
            if (Object.prototype.hasOwnProperty.call(fromObj, key)) {
                toObj[key] = fromObj[key];
            }
        });
    },
    //复制对象(深拷贝)
    cloneObj: function (obj) {
        if (typeof obj != "object") return obj;
        var newObj = {};
        if (obj instanceof Array) {
            newObj = [];
        }
        for (var key in obj) {
            var val = obj[key];
            //newObj[key] = typeof val === 'object' ? arguments.callee(val) : val; //arguments.callee 在哪一个函数中运行，它就代表哪个函数, 一般用在匿名函数中。
            newObj[key] = typeof val === "object" ? this.cloneObj(val) : val;
        }
        return newObj;
    },
    //设置对象的值
    setObjVal: function (obj, keys, val) {
        let keyArr = keys.split('.');
        let curkey = keyArr.shift();

        if (curkey) {
            if (!obj[curkey]) {
                obj[curkey] = {};
            } else if (typeof obj[curkey] != "object") {
                return obj[curkey];
            }
            obj[curkey] = this.setObjVal(obj[curkey], keyArr.join('.'), val);

            return obj;
        } else {
            return val;
        }
    },
    /**
     * 从数组中删除一个元素
     * @param arr
     * @param el
     */
    arrayRemove: function (arr, el) {
        let index = arr.indexOf(el);

        if (index > -1) {
            arr.splice(index, 1);
        }
    },

    /**
     * 判断某元素是否在数组中
     * @param arr
     * @param el
     */
    inArray(el, arr) {
        return arr.indexOf(el) !== -1;
    },

    //将字符串转为日期对象(兼容苹果手机)
    strToDate: function (str) {
        //苹果手机不支持 2018-12-12这种格式，只能写2018/12/12
        return new Date(str.replace(/-/g, '/'));
    },
    /**
     * 去除字符串两边指定的字符
     * @param str 要执行去除的字符串
     * @param trimChar 要去除的字符
     * @param type left:去除左边，rights：去除右边，空：去除两边
     * @returns {*}
     */
    trim: function (str, trimChar, type) {
        if (trimChar) {
            if (type === 'left') {
                return str.replace(new RegExp('^\\' + trimChar + '+', 'g'), '');
            } else if (type === 'right') {
                return str.replace(new RegExp('\\' + trimChar + '+$', 'g'), '');
            }
            return str.replace(new RegExp('^\\' + trimChar + '+|\\' + trimChar + '+$', 'g'), '');
        }
        return str.replace(/^\s+|\s+$/g, '');
    },

    /**
     * 格式化时间
     * @param date
     * @param fmt
     * @returns {*}
     */
    dateFormat: function (date, fmt) {
        var o = {
            "M+": date.getMonth() + 1, //月份
            "d+": date.getDate(), //日
            "h+": date.getHours(), //小时
            "m+": date.getMinutes(), //分
            "s+": date.getSeconds(), //秒
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度
            "S": date.getMilliseconds() //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    },

    /**
     * 写cookies
     * @param name cookie名称
     * @param value cookie值
     * @param ttl 生命时间(秒)
     */
    setCookie: function (name, value, ttl) {
        let cookieStr;
        if (ttl) {
            var exp = new Date();
            exp.setTime(exp.getTime() + ttl * 1000);
            cookieStr = name + "=" + escape(value) + ";expires=" + exp.toGMTString();
        } else {
            cookieStr = name + "=" + escape(value) + ";";
        }

        document.cookie = cookieStr;
    },

    //读取cookies
    getCookie: function (name) {
        let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)"); //正则匹配
        let arr = document.cookie.match(reg);
        if (arr) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    },

    /**
     * 删除cookies
     * @param name cookie名字
     * @param path cookie所在的路径
     */
    delCookie: function (name, path) {
        let defaultPath = '/';
        let exp = new Date();
        if (path) defaultPath = path;
        exp.setTime(exp.getTime() - 1);
        let cval = this.getCookie(name);
        if (cval != null) {
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ";path=" + defaultPath;
        }
    },

    //base64编码
    base64Encode: function (str) {
        return window.btoa(unescape(encodeURIComponent(str)));
    },
    //base64解码
    base64Decode: function (str) {
        return decodeURIComponent(escape(window.atob(str)));
    },
    //json编码
    jsonEncode: function (obj) {
        return JSON.stringify(obj);
    },
    //json解码
    jsonDecode: function (str) {
        return JSON.parse(str);
    },
}
